import initialState from '../initialState';
import * as types from './actionTypes.diffMode';

let initialStateObj = {
    scripts: initialState.diffMode.scripts,
    fromTagId: initialState.diffMode.fromTagId,
    toTagId: initialState.diffMode.toTagId,
    diffModeScriptsUpdateTs: initialState.diffMode.diffModeScriptsUpdateTs,
    selectedScript: initialState.diffMode.selectedScript,
    isLoading: initialState.diffMode.isLoading
};

export default function DiffModeReducer(state = initialStateObj, action) {
    switch (action.type) {
        case types.FILL_DIFF_MODE_OK:
        case types.OPEN_DIFF_MODE_OK:
            return {
                ...initialStateObj,
            };

        case types.CHANGE_VERSION_TAG_REQ:
            return {
                ...state,
                ...{ fromTagId: action.fromTagId },
                ...{ toTagId: action.toTagId },
                ...{ scripts: [] },
                ...{ diffModeScriptsUpdateTs: Date.now() },
                ...{ isLoading: true },
            };

        case types.COMPARE_VERSIONS_OK:
            return {
                ...state,
                ...{ fromTagId: action.fromTagId },
                ...{ toTagId: action.toTagId },
                ...{ scripts: action.scripts },
                ...{ diffModeScriptsUpdateTs: Date.now() },
                ...{ isLoading: false },
            };

        case types.CHANGE_SELECTED_SCRIPT_REQ:
            return {
                ...state,
                ...{ selectedScript: action.script },
                ...{ diffModeScriptsUpdateTs: Date.now() }
            };

        default:
            return state;
    }
}